import { usePermalinks } from "hooks/usePermalinks";
import { SiteDeviceSelection } from "./store/state";
import { useEffect } from "react";
import { liveStreamingThunks } from "./store/slice";
import { useAppDispatch } from "app/hooks";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import * as schema_sitedeviceselectionslist from "./ajvschemas/SiteDeviceSelectionlist.json";
import * as proto from "src/features/liveStreaming/protobuf/generated/sitedeviceselections_pb";

export interface PermalinkLiveStreamProps {
    siteDeviceSelections?: SiteDeviceSelection[];
}

export function PermalinkLiveStream(props: PermalinkLiveStreamProps) {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const { decodePermalink, encodePermalink } = usePermalinks<
        SiteDeviceSelection[]
    >(schema_sitedeviceselectionslist, proto.SiteDeviceSelectionlistSchema);

    useEffect(() => {
        if (
            props.siteDeviceSelections &&
            props.siteDeviceSelections.length > 0
        ) {
            const encodedResult = encodePermalink(props.siteDeviceSelections);
            if (encodedResult.hasError) {
                // toaster
                enqueueSnackbar(`Could not create Permalink.`, {
                    variant: "error",
                });
            } else {
                navigate(
                    "/livestreaming/" + encodedResult.base64UrlCompressed,
                    {
                        preventScrollReset: true,
                    },
                );
            }
        }
        // there is no data to hash so make sure the url is clean
        else if (
            props.siteDeviceSelections &&
            props.siteDeviceSelections.length === 0
        ) {
            navigate("/livestreaming/", {
                preventScrollReset: true,
            });
        }
    }, [encodePermalink, navigate, props.siteDeviceSelections]);

    useEffect(() => {
        if (!props.siteDeviceSelections) {
            const decodedResult = decodePermalink();

            if (!decodedResult.hasError && decodedResult.decodedData) {
                dispatch(
                    liveStreamingThunks.initializeSiteOnDeepLinkAsync(
                        decodedResult.decodedData,
                    ),
                );
            }
            if (decodedResult.hasError) {
                // toaster
                enqueueSnackbar(
                    `The address is not correct or is outdated. You will be redirected`,
                    {
                        variant: "error",
                    },
                );
                navigate("/livestreaming/", {
                    preventScrollReset: true,
                });
            }
        }
    }, [decodePermalink, dispatch, navigate, props.siteDeviceSelections]);
    return <></>;
}
